import {RsnInput} from '@raison/ui-kit';

type SelectionGetter = (element: HTMLInputElement, formattedValue: string) => readonly [number, number] | void;

export const createSelectionGetter =
    (isValueSymbol: (char: string) => boolean): SelectionGetter =>
    (inputEl, nextValue) => {
        const prevValue = inputEl.value;

        if (prevValue === nextValue) {
            return;
        }

        let counter = 0;
        const prevCaretPos = inputEl.selectionEnd ?? inputEl.value.length;

        for (let i = 0; i < prevValue.length; i++) {
            if (i === prevCaretPos) {
                break;
            }
            if (isValueSymbol(prevValue[i])) {
                counter++;
            }
        }

        let i = 0;
        for (; i < nextValue.length; i++) {
            if (counter === 0) {
                break;
            }
            if (isValueSymbol(nextValue[i])) {
                counter--;
            }
        }
        return [i, i] as const;
    };

export function createFormattingPlugin<T>(
    getSelection: SelectionGetter,
    toValue: (value: string) => T,
    toString: (value: T) => string
): RsnInput.Plugin<T> {
    return {
        beforeOnChange: (_, ev) => {
            const parsed = toValue(ev.target.value);
            const formatted = toString(parsed);
            const position = getSelection(ev.target, formatted);
            if (position) {
                requestAnimationFrame(() => ev.target.setSelectionRange(...position));
            }
            return parsed;
        },
        renderValue: value => toString(value),
    };
}

export const samePlaceSelection = createSelectionGetter(() => true);

export const uppercaseFormatting = createFormattingPlugin(
    createSelectionGetter(() => true),
    value => value.toUpperCase(),
    value => value.toUpperCase()
);
